import React from 'react';
import { connect } from 'react-redux';
import styles from './AssignLots.module.scss';
import { Paper, Checkbox } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { popLotsSelected } from '../../../../../../redux/siteplanManagement/action';

const AssignLots = (props) => {
	const { lotsSelected, popLotsSelected } = props;

	const handleLotCheckboxChange = (lotId) => {
		popLotsSelected(lotId);
	};

	return (
		<div className={styles.assign_lots}>
			<h3 className={styles.title}>Assigned unit(s)</h3>
			{Object.keys(lotsSelected)
				.filter((lotId) => lotsSelected[lotId])
				.map((lotId) => (
					<Paper className={styles.lot_card}>
						<div className={styles.header}>
							<div className={styles.lot_id}>Lot {lotId}</div>
							<Checkbox
								className={styles.lots_checkbox}
								checked={lotsSelected[lotId]}
								onChange={() => handleLotCheckboxChange(lotId)}
								checkedIcon={
									<CheckBoxIcon className={styles.checkbox} />
								}
							/>
						</div>
					</Paper>
				))}
		</div>
	);
};

const mapStateToProps = (state) => ({
	lotsSelected: state.siteplanManagement.lotsSelected,
});
export default connect(mapStateToProps, { popLotsSelected })(AssignLots);
